import React from "react";
import { WifiOff, RefreshCw } from "lucide-react";

export default function OfflineOverlay({ onRetry }) {
  return (
    <div className="fixed inset-0 z-[100] bg-[#121D28] flex flex-col items-center justify-center text-center px-6" data-testid="offline-overlay">
      <div className="absolute inset-0 opacity-[0.06]" style={{ backgroundImage: "linear-gradient(#38BDF8 1px, transparent 1px), linear-gradient(90deg, #38BDF8 1px, transparent 1px)", backgroundSize: "44px 44px" }} />
      <div className="relative flex flex-col items-center">
        <div className="w-16 h-16 rounded-[8px] bg-[#0B131C] border border-white/10 flex items-center justify-center mb-6 shadow-lg">
          <WifiOff size={30} className="text-[#38BDF8]" />
        </div>
        <div className="font-display text-3xl font-extrabold text-white tracking-tight">You're offline</div>
        <div className="text-slate-400 text-[15px] mt-3 max-w-md leading-relaxed">
          ALPHASYNC needs a connection for live market data. Reconnect to resume scanning
          Nifty&nbsp;50, S&amp;P&nbsp;500, ETFs and indices.
        </div>
        <button
          onClick={onRetry}
          data-testid="offline-retry"
          className="mt-7 inline-flex items-center gap-2 px-6 py-3 rounded-[6px] bg-[#0070BA] hover:bg-[#005B98] text-white text-[14px] font-semibold transition-colors shadow-md"
        >
          <RefreshCw size={16} /> Retry connection
        </button>
        <div className="mt-6 font-mono text-[11px] tracking-[0.2em] text-slate-600">ALPHASYNC · OFFLINE MODE</div>
      </div>
    </div>
  );
}
